import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderLink2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-link-2, link, attachment"><path d="M14.25 19.25H21.25V6.75H12L10 3.75H2.75V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 13.75H1.75V20.25H4.75M8.25 13.75H11.25V20.25H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.25 17H7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderLink2;
